import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=5fb25b2b&scoped=true&"
import script from "./Resellers.vue?vue&type=script&lang=js&"
export * from "./Resellers.vue?vue&type=script&lang=js&"
import style0 from "./Resellers.vue?vue&type=style&index=0&id=5fb25b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb25b2b",
  null
  
)

component.options.__file = "Resellers.vue"
export default component.exports